import React from "react";
import PropTypes from "prop-types";
import "./AccordeonMj.css";
var SpecificAccordeon = function (props) {
    var 
    // @ts-ignore
    children = props.children;
    return React.createElement("div", { className: "dsmj-specific" }, children);
};
SpecificAccordeon.defaultProps = { __TYPE: "SpecificAccordeon" };
SpecificAccordeon.propTypes = { __TYPE: PropTypes.string };
export default SpecificAccordeon;
